module.exports = __webpack_public_path__ + "static/media/al.633e8642.svg";